import { createAsyncThunk } from '@reduxjs/toolkit';

import { NewsService } from 'api';

import { GetNewsProps } from 'models';

export const getNewsTitles = createAsyncThunk(
	'news/getNewsTitles',
	async (params: GetNewsProps) => {
		return await NewsService.getTitles(params);
	},
);
